import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";

export function useScrollDirection(threshold = 0) {
  const router = useRouter();
  const lastScrollY = useRef(0);
  const [direction, setDirection] = useState();

  useEffect(() => {
    lastScrollY.current = window.pageYOffset;
    let ticking = false;

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;
      if (Math.abs(scrollY - lastScrollY.current) < threshold) {
        ticking = false;
        return;
      }
      setDirection(scrollY > lastScrollY.current ? "down" : "up");
      lastScrollY.current = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [direction]);

  useEffect(() => {
    const resetLastScrollY = () => {
      lastScrollY.current = window.pageYOffset;
      setDirection(null);
    };
    router.events.on("routeChangeComplete", resetLastScrollY);
    return () => {
      router.events.off("routeChangeComplete", resetLastScrollY);
    };
  }, []);

  return direction;
}
